module.exports = __webpack_public_path__ + "img/youtube-filled.62fcb7c5.svg";